import React from 'react'
import { useScrollAnimation } from '../../hooks/useScrollAnimation'
import { landingContent } from '../../config/content.config'
import { PhoneIcon, MailIcon, FaxIcon, GlobeIcon, BuildingIcon } from '../../assets/icons'
import Flag from '../../assets/flags'
import Badge from '../Badge/Badge'
import './Contact.css'

const Contact = () => {
  const { contact } = landingContent
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation()
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation()

  return (
    <section id="contact" className="contact-section">
      <div className="contact-section-inner">
        {/* Section Header */}
        <div
          ref={headerRef}
          className={`contact-section-header scroll-animate ${headerVisible ? 'is-visible' : ''}`}
        >
          <Badge className="contact-section-badge">{contact.header.label}</Badge>
          <h2 className="section-title">{contact.header.title}</h2>
        </div>

        {/* System Support Section */}
        <div
          ref={contentRef}
          className={`contact-content scroll-animate-container ${contentVisible ? 'is-visible' : ''}`}
        >

          {/* Sales and Marketing Support */}
          <div className="contact-block">
            <h3 className="contact-block-title">{contact.salesSupport.title}</h3>

            <div className="sales-locations">
              {contact.salesSupport.locations.map((location) => (
                <div key={location.id} className="card location-card">
                  <div className="card-header location-header">
                    <span className="location-flag">
                      <Flag code={location.code} className="flag-icon" />
                    </span>
                    <h4 className="location-name">{location.country}</h4>
                  </div>
                  <div className="location-details">
                    <div className="location-detail-row">
                      <span className="detail-icon" title="Address">
                        <BuildingIcon />
                      </span>
                      <div className="detail-value address-block">
                        <div className="company-name">{location.company}</div>
                        {location.address.map((line, idx) => (
                          <div key={idx}>{line}</div>
                        ))}
                      </div>
                    </div>
                    <div className="location-detail-row">
                      <span className="detail-icon" title="Telephone">
                        <PhoneIcon />
                      </span>
                      <a href={`tel:${location.telephone.replace(/\s/g, '')}`} className="detail-value contact-link">
                        {location.telephone}
                      </a>
                    </div>
                    {location.fax && (
                      <div className="location-detail-row">
                        <span className="detail-icon" title="Fax">
                          <FaxIcon />
                        </span>
                        <span className="detail-value">{location.fax}</span>
                      </div>
                    )}
                    <div className="location-detail-row">
                      <span className="detail-icon" title="Email">
                        <MailIcon />
                      </span>
                      <a href={`mailto:${location.email}`} className="detail-value contact-link">
                        {location.email}
                      </a>
                    </div>
                    <div className="location-detail-row">
                      <span className="detail-icon" title="Website">
                        <GlobeIcon />
                      </span>
                      <a href={location.website} target="_blank" rel="noopener noreferrer" className="detail-value contact-link">
                        {location.website.replace('https://', '')}
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>


          {/* System Support */}
          <div className="contact-block">
            <h3 className="contact-block-title">{contact.systemSupport.title}</h3>
            <p className="contact-block-description">{contact.systemSupport.description}</p>
            <div className="contact-block-wrapper">
              <div className="card system-support-card">
                <h4 className="card-title">{contact.systemSupport.company}</h4>
                <div className="contact-info-grid">
                  <div className="contact-info-row">
                    <span className="contact-info-icon" title="Toll Free">
                      <PhoneIcon />
                    </span>
                    <a href={`tel:${contact.systemSupport.tollFree.replace(/-/g, '')}`} className="contact-info-value">
                      {contact.systemSupport.tollFree}
                    </a>
                  </div>
                  <div className="contact-info-row">
                    <span className="contact-info-icon" title="Telephone">
                      <PhoneIcon />
                    </span>
                    <a href={`tel:${contact.systemSupport.tel.replace(/-/g, '')}`} className="contact-info-value">
                      {contact.systemSupport.tel}
                    </a>
                  </div>
                  <div className="contact-info-row">
                    <span className="contact-info-icon" title="Fax">
                      <FaxIcon />
                    </span>
                    <span className="contact-info-value">{contact.systemSupport.fax}</span>
                  </div>
                  <div className="contact-info-row">
                    <span className="contact-info-icon" title="Email">
                      <MailIcon />
                    </span>
                    <a href={`mailto:${contact.systemSupport.email}`} className="contact-info-value contact-link">
                      {contact.systemSupport.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact